<template>
  <div class="vue-slider-root">
    <input v-if="!disabled" v-bind="$attrs" type="range" :value="value" @input="input" class="vue-slider absolute" />
    <input
      v-else
      disabled
      v-bind="$attrs"
      type="range"
      :value="value"
      @input="input"
      class="vue-slider vue-slider-disabled"
    />
    <!-- <div
      v-for="(data, pos) in index"
      :key="'vue_slider_' + pos"
      :class="['absolute', data[4]]"
      :style="{
        left: data[0] === 0 ? '0' : data[0] === max ? '100%' : 'calc(100% / ' + max + ' * ' + data[0] + ')',
        width: 'calc(100% / ' + max + ' * ' + (data[1] - data[0]) + ')'
      }"
    ></div> -->

    <div class="vue-slider-gradient" :style="{ background: get_gradient }">
      <div
        v-for="(data, pos) in index"
        :key="'vue_slider_' + pos"
        class="vue-slider-separator"
        :style="{
          display: data[0] === 0 || data[0] === max ? 'none' : 'block',
          left: 'calc(100% / ' + max + ' * ' + data[0] + ')',
        }"
      ></div>
    </div>
    <div
      v-if="thumbColor === 'image'"
      class="vue-slider-image"
      :style="{
        left: 'calc(100% / ' + max + ' * ' + value + ')',
      }"
    >
      <img src="../assets/images/desktop/slider_thumb.svg" alt="" />
    </div>
    <div
      v-else
      class="vue-slider-ball absolute"
      :style="{
        left: 'calc(100% / ' + max + ' * ' + value + ')',
      }"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.vue-slider-root {
  position: relative;
  margin: 0 9px 0 3px;

  .absolute {
    position: absolute;
    top: calc(50% - 2px);
    height: 4px;
    z-index: 0;

    &.red {
      background-color: $calc_back;
    }

    &.orange {
      background-color: $list_back;
    }

    &.green {
      background-color: $pos_back;
    }

    &.dark_green {
      background-color: $typ_back;
    }

    &.vue-slider-ball {
      width: 26px;
      height: 26px;
      z-index: 1;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px $text_semi_light;
      background-color: $lighter_background;
      top: calc(50% - 8px);
      border-radius: 13px;
      transform: translateX(-50%);
    }

    &.vue-slider {
      z-index: 2;
      -webkit-appearance: none;
      width: 100%;
      border-radius: 4px;
      background: transparent;
      outline: none;
      opacity: 1;
      border: none;
      padding: 0;
      margin: 0;
    }
  }
}

.vue-slider-image {
  width: 5.2rem;
  height: 5.2rem;
  z-index: 1;
  top: calc(50% - 2.6rem + 5px);
  transform: translateX(-50%);
  position: absolute;

  img {
    width: 100%;
    max-width: 100%;
  }
}

.vue-slider-gradient {
  height: 10px;
  border-radius: 5px;
  position: absolute;
  z-index: 0;
  left: 0;
  right: 0;
  // background: linear-gradient(to right, #fe4e00, #a9d220 38%, #1bb759);

  .vue-slider-separator {
    position: absolute;
    width: 3px;
    top: 2px;
    height: 6px;
    transform: translateX(-50%);
    background-color: white;
  }
}

.vue-slider.vue-slider-disabled {
  background: $slider_disabled;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 50px;
  height: 50px;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  border: none;
  margin-top: 10px;
  margin-left: -10px;
}

.vue-slider.vue-slider-disabled::-webkit-slider-thumb {
  background: $slider_disabled;
}

.vue-slider::-moz-range-thumb {
  -moz-appearance: none;
  width: 50px;
  height: 50px;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  border: none;
  margin-top: 10px;
  margin-left: -10px;
}

.vue-slider.vue-slider-disabled::-webkit-slider-thumb {
  background: $slider_disabled;
}
</style>

<script>
export default {
  inheritAttrs: false,
  props: ["value", "barColor", "thumbColor", "disabled", "index"],
  data: function () {
    return {
      max: 0,
    };
  },
  computed: {
    get_gradient: function () {
      console.log(this.index);
      const ret = [];
      const i_len = this.index.length;
      for (let i = 0; i < i_len; i++) {
        let position, color;
        if (i == 0) {
          position = 0;
        } else {
          if (i_len == 2) {
            position = 50;
          } else if (i_len == 3) {
            if (i == 1) {
              position = (this.index[i][0] / 30) * 100;
            } else {
              position = ((this.index[i][0] / 30) * 100 + 100) / 2;
            }
          } else {
            position = (this.index[i][0] / 30) * 100;
          }
        }
        const cl = this.index[i][4];
        if (cl == "red") {
          color = "#FE4E00";
        } else if (cl == "orange") {
          color = "#D4A614";
        } else if (cl == "green") {
          color = "#C2D220";
        } else {
          color = "#61C43D";
        }
        ret.push([color, position]);
      }
      let color_last;
      const cll = ret[ret.length - 1][0];
      if (cll == "#FE4E00") {
        color_last = "#C2D220";
      } else if (cll == "#D4A614") {
        color_last = "#C2D220";
      } else if (cll == "#C2D220") {
        color_last = "#61C43D";
      } else {
        color_last = "#1BB759";
      }
      ret.push([color_last, 100]);
      // linear-gradient(to right, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 52%, rgba(0,212,255,1) 100%);
      const ret_str =
        "linear-gradient(to right, " + ret.map((x) => x[0] + " " + x[1].toFixed(2) + "%").join(", ") + ")";
      return ret_str;
    },
  },
  methods: {
    input: function ($event) {
      this.$emit("input", +$event.target.value);
    },
  },
  mounted: function () {
    this.max = this.$attrs.max;
  },
};
</script>
